import React, {Component} from "react"
import PropTypes from "prop-types"
import {Row, Col, Panel} from "react-bootstrap"

import {TextArea} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import TicketInstructions from "@irati-web/perks/src/components/Tickets/TicketInstructions"
import id from "@irati/utils/id"
import {
  containsLegacyBulletPoints,
  containsHtml,
  getErrorIfContains,
  containsInvalidDoubleBulletPoints
} from "@irati/utils/markdown"
import StyledMarkdownCol from "../deal/styled/MarkdownCol"
import withRewardOnChange from "./withRewardOnChange"

const getError = (value) => {
  if (!value) {
    return null
  }
  return getErrorIfContains(value, [
    containsLegacyBulletPoints,
    containsInvalidDoubleBulletPoints,
    containsHtml
  ])
}

export const schema = (required) =>
  Validation
    .string(required ? "This field is required" : null)
    .test(
      "description-md-valid",
      "error",
      (value) => {
        return Validation.customError(getError(value))
      }
    )

const PROPERTY = "redemptionInstructions"

class RedemptionInstructions extends Component {
  static propTypes = {
    reward: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    required: PropTypes.bool,
    label: PropTypes.string,
    panelTitle: PropTypes.string
  }

  static defaultProps = {
    required: true,
    label: "Redemption instructions:",
    hint: "Available markdown: Bullet points, italic styling, bold styling, italic bold styling, images, paragraphs.",
    panelTitle: "How it will display",
    id: "redemptionInstructions"
  }

  render() {
    const {reward, required, label, panelTitle, onChange, ...props} = this.props

    return (
      <Row>
        <Col xs={6}>
          <TextArea
            name={PROPERTY}
            value={reward[PROPERTY]}
            validation={schema(required)}
            rows={8}
            label={`${label}${required ? "*" : ""}`}
            {...props}
            onChange={(value) => onChange(reward, PROPERTY, value)}
            id={id(PROPERTY, props)} />
        </Col>
        <StyledMarkdownCol xs={6}>
          <Panel bsStyle="info" header={panelTitle}>
            <TicketInstructions item={reward} instructions={reward[PROPERTY]} />
          </Panel>
        </StyledMarkdownCol>
      </Row>
    )
  }
}

export default withRewardOnChange(RedemptionInstructions)
